export default function anchor (anchor) {
  $('.anchor').css({
    paddingTop: $('header').outerHeight(),
    marginTop: $('header').outerHeight() * -1,
  })
}